import { useSelector } from "react-redux";
import RecordClassMobile from "./MobileRecordClass";
import { useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { Record_Class } from "../../Action/LiveClassAction";
import { FaFilter } from "react-icons/fa";
import Lock from "../../Components/Lock";
import SidePanel from "../../Components/SidePanel";
import ReactHelmet from "../../Components/ReactHelmet";
import Styles from "./RecordC.module.css";
import Loading from "../../Components/Loading";
import TopBar from "../../Components/TopBar";
import RightSidePanel from "../../Components/RightSidePanel";
export default function RecordClass() {
  const { PackageData } = useSelector((s) => s.SelectStudentPackageReducer);
  const [SideOpener, setSideOpner] = useState(false);
  const [Expanded, setExpanded] = useState(0);
  const [ClassFilter, setClassFilter] = useState("All");
  const [PlayVideo, setPlayVideo] = useState("");
  const [search, setsearch] = useState("");

  const [SidebarOpen, SetSideBarOpen] = useState(false);
  const Mobile_Screen = window.innerWidth;
  const [OpenMenuBar2, setOpenMenuBar2] = useState(false);

  const [ClassList, setClassList] = useState([]);

  const { loading, error, classRecs } = useSelector(
    (s) => s.list_LiveClassReducer
  );

  const dispatch = useDispatch();
  // const OpenSideMenu = (e) => {
  //   setSideOpner(!SideOpener);
  // };

  const FilterClasses = useCallback(() => {
    if (classRecs) {
      let c = classRecs?.filter((ev) => {
        let m =
          ev?.title?.toLowerCase()?.includes(search?.toLowerCase()) ||
          ev?.description?.toLowerCase()?.includes(search?.toLowerCase());
        let k = ClassFilter == "All" || ClassFilter == ev?.CourseName;
        if (search) {
          return m && k;
        } else {
        }
        return k;
      });

      setClassList([...c]);
    }
  }, [ClassFilter, search, classRecs]);

  useEffect(() => {
    if (PackageData) {
      dispatch(Record_Class(PackageData?._id));
    }
  }, [PackageData, dispatch]);

  useEffect(() => {
    FilterClasses();
  }, [FilterClasses]);

  return window.innerWidth <= 480 ? (
    <RecordClassMobile PackageData={PackageData} />
  ) : (
    <>
      <div className={Styles.Dashboard}>
        <ReactHelmet
          title={"Recorded Classes"}
          description={"Testifyi Recorded Classes"}
        />
        {/* SidePanel */}
        {loading ? <Loading /> : ""}

        {Mobile_Screen >= 780 ? (
          <SidePanel
            SetSideBarOpen={SetSideBarOpen}
            SidebarOpen={SidebarOpen}
            Page="Recorded Classes"
          />
        ) : (
          ""
        )}

        {Mobile_Screen <= 480 && SidebarOpen ? (
          <SidePanel
            SetSideBarOpen={SetSideBarOpen}
            SidebarOpen={SidebarOpen}
            Page="Recorded Classes"
          />
        ) : (
          ""
        )}

        <section className={Styles.MiddleSection}>
          <div>
            <TopBar
              SetSideBarOpen={SetSideBarOpen}
              SidebarOpen={SidebarOpen}
              SetSideBarOpen2={setOpenMenuBar2}
              SidebarOpen2={OpenMenuBar2}
              PageName={"Recorded Classes"}
            />
          </div>

          <div>
            <div className="Record_Class_Mbl">
              {classRecs ? (
                <main className="main">
                  <div className="container">
                    {/* <!-- Search Section --> */}
                    <div className="search-section">
                      <div className="search-container">
                        <div className="search-icon">🔍</div>
                        <input
                          type="text"
                          className="search-input"
                          placeholder="Search for classes, instructors, or topics..."
                          onChange={(e) => setsearch(e.target.value)}
                          id="searchInput"
                        />
                      </div>

                      <div className="filters">
                        <span className="filter-label">
                          <FaFilter /> Filter by:
                        </span>
                        <button
                          className={`filter-btn ${
                            ClassFilter == "All" ? "active" : ""
                          }`}
                          onClick={() => setClassFilter("All")}
                          data-category="all"
                        >
                          All
                        </button>
                        <button
                          className={`filter-btn ${
                            ClassFilter == "IELTS" ? "active" : ""
                          }`}
                          onClick={() => setClassFilter("IELTS")}
                          data-category="ielts"
                        >
                          IELTS
                        </button>
                        <button
                          className={`filter-btn ${
                            ClassFilter == "PTE" ? "active" : ""
                          }`}
                          onClick={() => setClassFilter("PTE")}
                          data-category="pte"
                        >
                          PTE
                        </button>
                        <button
                          className={`filter-btn ${
                            ClassFilter == "DUOLINGO" ? "active" : ""
                          }`}
                          onClick={() => setClassFilter("DUOLINGO")}
                          data-category="duolingo"
                        >
                          Duolingo
                        </button>
                      </div>
                    </div>

                    {/* <!-- Classes Grid --> */}
                    <div className="classes-grid" style={{padding:"0 30px"}}>
                      {/* <!-- IELTS Speaking Class --> */}

                      {ClassList?.map((em) => (
                        <div
                          className={
                            Expanded == em?._id
                              ? "class-card expanded"
                              : "class-card"
                          }
                          data-category={em?.CourseName?.toLowerCase()}
                        >
                          <div className="class-header" style={{display:"block"}}>
                            <div className="class-thumbnail">
                              <img  src={em?.thumbnail} alt={em?.title} />
                            </div>
                            <div className="class-info">
                              <div className="class-meta">
                                <h3 className="class-title">{em?.title}</h3>
                                {/* <p className="instructor">by Sarah Johnson</p> */}
                                <span
                                  className={`category-badge ${em?.CourseName?.toLowerCase()}`}
                                >
                                  {em?.CourseName}
                                </span>
                              </div>
                              <p className="class-description">
                                {em?.description}
                              </p>
                              <div className="class-stats">
                                <span className="stat">
                                  ▶ {em?.lecturesCount} lectures
                                </span>
                                {/* <span className="stat">⏱ 3h 45m</span> */}
                              </div>
                              {/* <div className="progress-section">
                                    <div className="progress-info">
                                      <span>Progress</span>
                                      <span>75%</span>
                                    </div>
                                    <div className="progress-bar">
                                      <div
                                        className="progress-fill"
                                        style={{ width: "75%" }}
                                      ></div>
                                    </div>
                                  </div> */}
                            </div>
                          </div>

                          <div className="class-actions">
                            <button
                              className="expand-btn"
                              onClick={() => {
                                if (Expanded == em?._id) {
                                  setExpanded("");
                                } else {
                                  setExpanded(em?._id);
                                }
                              }}
                            >
                              <span className="expand-text">View Lectures</span>
                              <span className="expand-icon">⌄</span>
                            </button>
                          </div>

                          {/* <!-- Lectures Section (Hidden by default) --> */}
                          <div className="lectures-section">
                            <h4 className="lectures-title">Course Lectures</h4>
                            <div className="lectures-list">
                              {em?.lectures?.map((ev, j) => (
                                <div
                                  className="lecture-item"
                                  style={{ display: "block" }}
                                >
                                  <div>
                                    <div className="class-thumbnail video-sec">
                                      <img
                                        style={
                                          PlayVideo == ev?._id
                                            ? { display: "none" }
                                            : { display: "block" }
                                        }
                                        src={em?.thumbnail}
                                        alt={em?.title}
                                      />
                                      <div
                                        style={
                                          PlayVideo == ev?._id
                                            ? { display: "none" }
                                            : { display: "block" }
                                        }
                                        class="play-button"
                                        onClick={() => setPlayVideo(ev?._id)}
                                      >
                                        ▶
                                      </div>

                                      <div
                                        class="iframe-wrapper"
                                        style={
                                          PlayVideo == ev?._id
                                            ? { display: "block" }
                                            : { display: "none" }
                                        }
                                        id="videoFrame"
                                      >
                                        <iframe
                                          style={{
                                            width: "100%",
                                            height: "200px",
                                          }}
                                          src={
                                        PlayVideo == ev?._id
                                          ? `${ev?.Video_Url}?autoplay=1&controls=1`
                                          : ""
                                      }
                                          title="Video Player"
                                          frameborder="0"
                                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                                          allowfullscreen
                                        ></iframe>
                                      </div>
                                    </div>
                                  </div>

                                  <div style={{ padding: "20px 0" }}>
                                    <div className="lecture-content">
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "10px",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="lecture-number">
                                          {j + 1}
                                        </div>
                                        <h5 className="lecture-title">
                                          {ev?.title}
                                        </h5>
                                      </div>

                                      <p className="lecture-description">
                                        {ev?.description}
                                      </p>
                                      <div className="lecture-meta">
                                        {/* <span className="lecture-date">
                                            📅 Jan 15, 2024
                                          </span> */}
                                        {/* <span className="lecture-duration">
                                              ⏱ 45 min
                                            </span> */}
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div className="lecture-status">
                                        <span className="status-badge watched">
                                          ✓ Watched
                                        </span>
                                      </div> */}
                                  <div className="lecture-actions">
                                    <button
                                      className={
                                        PlayVideo == ev?._id
                                          ? "btn-secondary"
                                          : "btn-primary"
                                      }
                                      onClick={() => {
                                        if (PlayVideo == ev?._id) {
                                          setPlayVideo("");
                                        } else setPlayVideo(ev?._id);
                                      }}
                                    >
                                      {PlayVideo == ev?._id
                                        ? "Cancel Now"
                                        : "▶ Watch Now"}
                                    </button>
                                    {/* <button className="btn-secondary">
                                          👁 Preview
                                        </button> */}
                                    {/* <div className="materials">
                                          <span className="materials-label">
                                            Materials:
                                          </span>
                                          <button
                                            className="material-btn"
                                            title="Speaking Guide.pdf (2.5 MB)"
                                          >
                                            📄 ⬇
                                          </button>
                                          <button
                                            className="material-btn"
                                            title="Practice Questions.docx (1.2 MB)"
                                          >
                                            📝 ⬇
                                          </button>
                                        </div> */}
                                  </div>
                                </div>
                              ))}

                              {/* <div className="lecture-item">
                                    <div className="lecture-number">2</div>
                                    <div className="lecture-content">
                                      <h5 className="lecture-title">
                                        Part 1: Personal Questions
                                      </h5>
                                      <p className="lecture-description">
                                        Mastering personal questions and building
                                        confidence
                                      </p>
                                      <div className="lecture-meta">
                                        <span className="lecture-date">
                                          📅 Jan 16, 2024
                                        </span>
                                        <span className="lecture-duration">
                                          ⏱ 55 min
                                        </span>
                                      </div>
                                    </div>
                                    <div className="lecture-status">
                                      <span className="status-badge watched">
                                        ✓ Watched
                                      </span>
                                    </div>
                                    <div className="lecture-actions">
                                      <button className="btn-primary">
                                        ▶ Watch Now
                                      </button>
                                      <button className="btn-secondary">
                                        👁 Preview
                                      </button>
                                      <div className="materials">
                                        <span className="materials-label">
                                          Materials:
                                        </span>
                                        <button
                                          className="material-btn"
                                          title="Part 1 Templates.pdf (1.8 MB)"
                                        >
                                          📄 ⬇
                                        </button>
                                      </div>
                                    </div>
                                  </div>
        
                                  <div className="lecture-item">
                                    <div className="lecture-number">3</div>
                                    <div className="lecture-content">
                                      <h5 className="lecture-title">
                                        Part 2: Cue Card Mastery
                                      </h5>
                                      <p className="lecture-description">
                                        Strategies for the 2-minute speech with cue
                                        cards
                                      </p>
                                      <div className="lecture-meta">
                                        <span className="lecture-date">
                                          📅 Jan 17, 2024
                                        </span>
                                        <span className="lecture-duration">
                                          ⏱ 1h 10m
                                        </span>
                                      </div>
                                    </div>
                                    <div className="lecture-status">
                                      <span className="status-badge watched">
                                        ✓ Watched
                                      </span>
                                    </div>
                                    <div className="lecture-actions">
                                      <button className="btn-primary">
                                        ▶ Watch Now
                                      </button>
                                      <button className="btn-secondary">
                                        👁 Preview
                                      </button>
                                      <div className="materials">
                                        <span className="materials-label">
                                          Materials:
                                        </span>
                                        <button
                                          className="material-btn"
                                          title="Cue Card Topics.pdf (3.1 MB)"
                                        >
                                          📄 ⬇
                                        </button>
                                        <button
                                          className="material-btn"
                                          title="Sample Answers.mp3 (15.2 MB)"
                                        >
                                          🎵 ⬇
                                        </button>
                                      </div>
                                    </div>
                                  </div>
        
                                  <div className="lecture-item">
                                    <div className="lecture-number">4</div>
                                    <div className="lecture-content">
                                      <h5 className="lecture-title">
                                        Part 3: Discussion & Advanced Topics
                                      </h5>
                                      <p className="lecture-description">
                                        Handling complex discussions and abstract topics
                                      </p>
                                      <div className="lecture-meta">
                                        <span className="lecture-date">
                                          📅 Jan 18, 2024
                                        </span>
                                        <span className="lecture-duration">
                                          ⏱ 50 min
                                        </span>
                                      </div>
                                    </div>
                                    <div className="lecture-status">
                                      <span className="status-badge not-watched">
                                        ○ Not Watched
                                      </span>
                                    </div>
                                    <div className="lecture-actions">
                                      <button className="btn-primary">
                                        ▶ Watch Now
                                      </button>
                                      <button className="btn-secondary">
                                        👁 Preview
                                      </button>
                                      <div className="materials">
                                        <span className="materials-label">
                                          Materials:
                                        </span>
                                        <button
                                          className="material-btn"
                                          title="Discussion Topics.pdf (2.8 MB)"
                                        >
                                          📄 ⬇
                                        </button>
                                      </div>
                                    </div>
                                  </div> */}
                            </div>
                          </div>
                        </div>
                      ))}

                      {/* <!-- PTE Writing Class --> */}
                      {/* <div className="class-card" data-category="pte">
                            <div className="class-header">
                              <div className="class-thumbnail">
                                <img
                                  src="https://images.pexels.com/photos/7688336/pexels-photo-7688336.jpeg?auto=compress&cs=tinysrgb&w=400"
                                  alt="PTE Writing"
                                />
                              </div>
        
                              <div className="class-info">
                                <div className="class-meta">
                                  <h3 className="class-title">
                                    PTE Academic Writing Workshop
                                  </h3>
                               
                                  <span className="category-badge pte">PTE</span>
                                </div>
                                <p className="class-description">
                                  Comprehensive PTE Academic Writing strategies and
                                  practice
                                </p>
                                <div className="class-stats">
                                  <span className="stat">▶ 4 lectures</span>
                                  <span className="stat">⏱ 4h 20m</span>
                                </div>
                                <div className="progress-section">
                                  <div className="progress-info">
                                    <span>Progress</span>
                                    <span>25%</span>
                                  </div>
                                  <div className="progress-bar">
                                    <div
                                      className="progress-fill"
                                      style={{ width: "25%" }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
        
                            <div className="class-actions">
                              <button className="expand-btn">
                                <span className="expand-text">View Lectures</span>
                                <span className="expand-icon">⌄</span>
                              </button>
                            </div>
        
                            <div className="lectures-section">
                              <h4 className="lectures-title">Course Lectures</h4>
                              <div className="lectures-list">
                                <div className="lecture-item">
                                  <div className="lecture-number">1</div>
                                  <div className="lecture-content">
                                    <h5 className="lecture-title">
                                      Essay Writing Fundamentals
                                    </h5>
                                    <p className="lecture-description">
                                      Understanding PTE essay structure and scoring
                                      criteria
                                    </p>
                                    <div className="lecture-meta">
                                      <span className="lecture-date">
                                        📅 Jan 20, 2024
                                      </span>
                                      <span className="lecture-duration">⏱ 1h 5m</span>
                                    </div>
                                  </div>
                                  <div className="lecture-status">
                                    <span className="status-badge watched">
                                      ✓ Watched
                                    </span>
                                  </div>
                                  <div className="lecture-actions">
                                    <button className="btn-primary">▶ Watch Now</button>
                                    <button className="btn-secondary">👁 Preview</button>
                                    <div className="materials">
                                      <span className="materials-label">
                                        Materials:
                                      </span>
                                      <button
                                        className="material-btn"
                                        title="Essay Templates.pdf (2.2 MB)"
                                      >
                                        📄 ⬇
                                      </button>
                                    </div>
                                  </div>
                                </div>
        
                                <div className="lecture-item">
                                  <div className="lecture-number">2</div>
                                  <div className="lecture-content">
                                    <h5 className="lecture-title">
                                      Summarize Written Text
                                    </h5>
                                    <p className="lecture-description">
                                      Techniques for effective text summarization
                                    </p>
                                    <div className="lecture-meta">
                                      <span className="lecture-date">
                                        📅 Jan 21, 2024
                                      </span>
                                      <span className="lecture-duration">⏱ 55 min</span>
                                    </div>
                                  </div>
                                  <div className="lecture-status">
                                    <span className="status-badge not-watched">
                                      ○ Not Watched
                                    </span>
                                  </div>
                                  <div className="lecture-actions">
                                    <button className="btn-primary">▶ Watch Now</button>
                                    <button className="btn-secondary">👁 Preview</button>
                                    <div className="materials">
                                      <span className="materials-label">
                                        Materials:
                                      </span>
                                      <button
                                        className="material-btn"
                                        title="Summary Examples.pdf (1.9 MB)"
                                      >
                                        📄 ⬇
                                      </button>
                                    </div>
                                  </div>
                                </div>
        
                                <div className="lecture-item">
                                  <div className="lecture-number">3</div>
                                  <div className="lecture-content">
                                    <h5 className="lecture-title">
                                      Write Essay - Advanced Techniques
                                    </h5>
                                    <p className="lecture-description">
                                      Advanced essay writing strategies and time
                                      management
                                    </p>
                                    <div className="lecture-meta">
                                      <span className="lecture-date">
                                        📅 Jan 22, 2024
                                      </span>
                                      <span className="lecture-duration">⏱ 1h 15m</span>
                                    </div>
                                  </div>
                                  <div className="lecture-status">
                                    <span className="status-badge not-watched">
                                      ○ Not Watched
                                    </span>
                                  </div>
                                  <div className="lecture-actions">
                                    <button className="btn-primary">▶ Watch Now</button>
                                    <button className="btn-secondary">👁 Preview</button>
                                    <div className="materials">
                                      <span className="materials-label">
                                        Materials:
                                      </span>
                                      <button
                                        className="material-btn"
                                        title="Advanced Templates.pdf (2.7 MB)"
                                      >
                                        📄 ⬇
                                      </button>
                                    </div>
                                  </div>
                                </div>
        
                                <div className="lecture-item">
                                  <div className="lecture-number">4</div>
                                  <div className="lecture-content">
                                    <h5 className="lecture-title">
                                      Practice & Review Session
                                    </h5>
                                    <p className="lecture-description">
                                      Mock tests and personalized feedback
                                    </p>
                                    <div className="lecture-meta">
                                      <span className="lecture-date">
                                        📅 Jan 23, 2024
                                      </span>
                                      <span className="lecture-duration">⏱ 1h 5m</span>
                                    </div>
                                  </div>
                                  <div className="lecture-status">
                                    <span className="status-badge not-watched">
                                      ○ Not Watched
                                    </span>
                                  </div>
                                  <div className="lecture-actions">
                                    <button className="btn-primary">▶ Watch Now</button>
                                    <button className="btn-secondary">👁 Preview</button>
                                    <div className="materials">
                                      <span className="materials-label">
                                        Materials:
                                      </span>
                                      <button
                                        className="material-btn"
                                        title="Mock Tests.pdf (4.1 MB)"
                                      >
                                        📄 ⬇
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}

                      {/* <!-- Duolingo Test Class --> */}
                      {/* <div className="class-card" data-category="duolingo">
                            <div className="class-header">
                              <div className="class-thumbnail">
                                <img
                                  src="https://images.pexels.com/photos/5428836/pexels-photo-5428836.jpeg?auto=compress&cs=tinysrgb&w=400"
                                  alt="Duolingo Test"
                                />
                              </div>
                              <div className="class-info">
                                <div className="class-meta">
                                  <h3 className="class-title">
                                    Duolingo English Test Preparation
                                  </h3>
                             
                                  <span className="category-badge duolingo">
                                    Duolingo
                                  </span>
                                </div>
                                <p className="class-description">
                                  Complete preparation for Duolingo English Test
                                </p>
                                <div className="class-stats">
                                  <span className="stat">▶ 4 lectures</span>
                                  <span className="stat">⏱ 3h 30m</span>
                                </div>
                                <div className="progress-section">
                                  <div className="progress-info">
                                    <span>Progress</span>
                                    <span>50%</span>
                                  </div>
                                  <div className="progress-bar">
                                    <div
                                      className="progress-fill"
                                      style={{ width: "55%" }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
        
                            <div className="class-actions">
                              <button className="expand-btn">
                                <span className="expand-text">View Lectures</span>
                                <span className="expand-icon">⌄</span>
                              </button>
                            </div>
        
                            <div className="lectures-section">
                              <h4 className="lectures-title">Course Lectures</h4>
                              <div className="lectures-list">
                                <div className="lecture-item">
                                  <div className="lecture-number">1</div>
                                  <div className="lecture-content">
                                    <h5 className="lecture-title">
                                      DET Overview & Format
                                    </h5>
                                    <p className="lecture-description">
                                      Understanding the adaptive nature of DET
                                    </p>
                                    <div className="lecture-meta">
                                      <span className="lecture-date">
                                        📅 Jan 25, 2024
                                      </span>
                                      <span className="lecture-duration">⏱ 40 min</span>
                                    </div>
                                  </div>
                                  <div className="lecture-status">
                                    <span className="status-badge watched">
                                      ✓ Watched
                                    </span>
                                  </div>
                                  <div className="lecture-actions">
                                    <button className="btn-primary">▶ Watch Now</button>
                                    <button className="btn-secondary">👁 Preview</button>
                                    <div className="materials">
                                      <span className="materials-label">
                                        Materials:
                                      </span>
                                      <button
                                        className="material-btn"
                                        title="DET Guide.pdf (1.8 MB)"
                                      >
                                        📄 ⬇
                                      </button>
                                    </div>
                                  </div>
                                </div>
        
                                <div className="lecture-item">
                                  <div className="lecture-number">2</div>
                                  <div className="lecture-content">
                                    <h5 className="lecture-title">
                                      Reading & Listening Strategies
                                    </h5>
                                    <p className="lecture-description">
                                      Effective techniques for reading and listening
                                      sections
                                    </p>
                                    <div className="lecture-meta">
                                      <span className="lecture-date">
                                        📅 Jan 26, 2024
                                      </span>
                                      <span className="lecture-duration">⏱ 1h</span>
                                    </div>
                                  </div>
                                  <div className="lecture-status">
                                    <span className="status-badge watched">
                                      ✓ Watched
                                    </span>
                                  </div>
                                  <div className="lecture-actions">
                                    <button className="btn-primary">▶ Watch Now</button>
                                    <button className="btn-secondary">👁 Preview</button>
                                    <div className="materials">
                                      <span className="materials-label">
                                        Materials:
                                      </span>
                                      <button
                                        className="material-btn"
                                        title="Practice Exercises.pdf (2.5 MB)"
                                      >
                                        📄 ⬇
                                      </button>
                                    </div>
                                  </div>
                                </div>
        
                                <div className="lecture-item">
                                  <div className="lecture-number">3</div>
                                  <div className="lecture-content">
                                    <h5 className="lecture-title">
                                      Speaking & Writing Tasks
                                    </h5>
                                    <p className="lecture-description">
                                      Mastering speaking and writing components
                                    </p>
                                    <div className="lecture-meta">
                                      <span className="lecture-date">
                                        📅 Jan 27, 2024
                                      </span>
                                      <span className="lecture-duration">⏱ 1h 10m</span>
                                    </div>
                                  </div>
                                  <div className="lecture-status">
                                    <span className="status-badge not-watched">
                                      ○ Not Watched
                                    </span>
                                  </div>
                                  <div className="lecture-actions">
                                    <button className="btn-primary">▶ Watch Now</button>
                                    <button className="btn-secondary">👁 Preview</button>
                                    <div className="materials">
                                      <span className="materials-label">
                                        Materials:
                                      </span>
                                      <button
                                        className="material-btn"
                                        title="Speaking Tips.pdf (2.1 MB)"
                                      >
                                        📄 ⬇
                                      </button>
                                    </div>
                                  </div>
                                </div>
        
                                <div className="lecture-item">
                                  <div className="lecture-number">4</div>
                                  <div className="lecture-content">
                                    <h5 className="lecture-title">
                                      Mock Test & Final Review
                                    </h5>
                                    <p className="lecture-description">
                                      Complete mock test with detailed feedback
                                    </p>
                                    <div className="lecture-meta">
                                      <span className="lecture-date">
                                        📅 Jan 28, 2024
                                      </span>
                                      <span className="lecture-duration">⏱ 40 min</span>
                                    </div>
                                  </div>
                                  <div className="lecture-status">
                                    <span className="status-badge not-watched">
                                      ○ Not Watched
                                    </span>
                                  </div>
                                  <div className="lecture-actions">
                                    <button className="btn-primary">▶ Watch Now</button>
                                    <button className="btn-secondary">👁 Preview</button>
                                    <div className="materials">
                                      <span className="materials-label">
                                        Materials:
                                      </span>
                                      <button
                                        className="material-btn"
                                        title="Mock Test.pdf (3.2 MB)"
                                      >
                                        📄 ⬇
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                    </div>
                    {/* <!-- No Results Message --> */}
                    <div
                      className="no-results"
                      id="noResults"
                      style={
                        ClassList?.length
                          ? { display: "none" }
                          : { display: "block" }
                      }
                    >
                      <div className="no-results-icon">🔍</div>
                      <h3>No classes found</h3>
                      <p>
                        Try adjusting your search or filters to find what you're
                        looking for.
                      </p>
                    </div>
                  </div>
                </main>
              ) : (
                <Lock texts={"Coming Soon"} />
              )}
            </div>
          </div>
        </section>

        <RightSidePanel
          SetSideBarOpen={setOpenMenuBar2}
          SidebarOpen={OpenMenuBar2}
        />
      </div>
    </>
  );
}
